var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allow_user_inference)?_c('div',{staticClass:"text-right"},[_c('b-button',{staticClass:"user-cta__action has-icon",attrs:{"size":"sm","variant":"light","disabled":_vm.checking},on:{"click":_vm.onClick}},[_c('Icon',{attrs:{"name":"magicWand","width":"22"}}),_vm._v("\n    "+_vm._s(_vm.$t('modal_face_inference.cta'))+"\n  ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }